module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/union-8523b32e29613170b44c170d6641f414.svg";